import TicketLine from "public/ui-elements/ticket-line.svg";
import TicketLineM from "public/ui-elements/ticket-line-m.svg";
import { type ComponentProps, useCallback } from "react";

import { parseLinkParams } from "@shared/utils";

import { Details } from "../components/details";
import { Price } from "../components/price";
import type { TicketType } from "../model";

import s from "./ticket-card.module.scss";

export type TicketCardProps = ComponentProps<"div"> & {
  data: TicketType;
};

export const TicketCard = (props: TicketCardProps) => {
  const { data } = props;

  const handleBuy = useCallback(() => {
    if (!data.widgetLink) {
      console.warn("[Ticket] Не передана ссылка для покупки билета");
      return;
    }

    if (!window.WPOpenModal) {
      console.error("[Ticket] WPOpenModal не подключен");
      return;
    }

    const params = parseLinkParams(data.widgetLink);

    window.WPOpenModal(params);
  }, [data.widgetLink]);

  return (
    <article className={s.root}>
      <Details onBuyClick={handleBuy} data={data} />
      <TicketLine className={s.ticketLine} />
      <TicketLineM className={s.ticketLineMobile} />
      <Price
        data={data.price}
        onBuyClick={handleBuy}
        hasLink={!!data.widgetLink}
      />
    </article>
  );
};

TicketCard.displayName = "TicketCard";
